import React from "react";

export const AllVendorTableHead = (props) => {
  return (
    <tr>
      <th style={{ width: "12%" }}>
        Business
        <br />
        Id
      </th>
      <th style={{ width: "14%" }}>Business Name</th>
      <th style={{ width: "16%" }}>Primary Contact</th>
      <th style={{ width: "6%" }}>City</th>
      <th style={{ width: "6%" }}>
        Area/
        <br />
        Zip code
      </th>
      <th style={{ width: "6%" }}>
        Referral
        <br />
        Code
      </th>
      {/* <th style={{ width: "18%" }}>Address</th> */}
      {/* <th style={{ width: "8%" }}>
        Area <br /> Zip code
      </th>
      <th style={{ width: "8%" }}>
        Referral <br /> Code
      </th>*/}
      <th style={{ width: "10%" }}>
        Profile <br /> Completion %
      </th>
      <th style={{ width: "12%" }}>
        Restaurant
        <br /> Type
      </th>
      <th style={{ width: "7%" }}>Status</th>
      <th style={{ width: "11%", textAlign: "right" }}>Actions</th>
    </tr>
  );
};
